import {
  CentraCheckoutApiMappers,
  defaultCentraCheckoutApiMappers,
} from "@made-people/grease-centra";
import { getLocalizedItemSizeFromSelectionItem } from "./utils/get-localized-item-size";
import { getTableMappingIdForCountryCode } from "./utils/get-table-mapping-id-for-country-code";

export const mmLineItem: CentraCheckoutApiMappers["centraSelectionItemToGreaseLineItem"] =
  (item, product, options, currencyFormat, mappers) => {
    const activeTableMapping = getTableMappingIdForCountryCode(
      options.context.countryCode,
    );
    const tableMapping = item.product.tableMappings?.[activeTableMapping];

    const basicItem =
      defaultCentraCheckoutApiMappers.centraSelectionItemToGreaseLineItem(
        item,
        product,
        options,
        currencyFormat,
        mappers,
      );

    if (!tableMapping) {
      return basicItem;
    }

    const localizedItemSize = getLocalizedItemSizeFromSelectionItem(
      item,
      tableMapping,
    );

    return {
      ...basicItem,
      itemDimensions: [
        {
          value: localizedItemSize,
          valueLabel: localizedItemSize,
          dimensionKey: "size",
          dimensionLabel: "size",
        },
      ],
    };
  };
